/**
 * Working Hours admin permissions from dynamic menu cache (hdDynamicMenuCache).
 */

import { loadMenuDataForNavigation } from './notificationNavigation';
import { toScreenKey } from './kbScreenPermissions';

const WORKING_HOURS_SCREEN_KEYS = new Set(['working-hours']);

const WORKING_HOURS_ROUTE_SUFFIXES = ['/admin/settings/working-hours'];

function normalizeRoute(screen) {
  return String(screen?.routing || screen?.route || '')
    .replace(/\/+$/, '')
    .toLowerCase();
}

function screenKeysFor(screen) {
  const keys = new Set();
  const name = screen?.screenName || screen?.screen_name;
  const label = screen?.screenLable || screen?.screen_label || screen?.screenLabel;
  if (name) keys.add(toScreenKey(name));
  if (label) keys.add(toScreenKey(label));
  return keys;
}

function permissionsFromScreen(screen) {
  if (!screen) {
    return { canView: false, canInsert: false, canUpdate: false, canDelete: false };
  }
  return {
    canView: Boolean(screen.canView),
    canInsert: Boolean(screen.canInsert),
    canUpdate: Boolean(screen.canUpdate),
    canDelete: Boolean(screen.canDelete),
  };
}

function screenHasAnyAccess(screen) {
  return Boolean(
    screen?.canView || screen?.canUpdate || screen?.canInsert || screen?.canDelete
  );
}

function matchesScreenKeySet(screen, keySet) {
  const keys = screenKeysFor(screen);
  for (const k of keys) {
    if (keySet.has(k)) return true;
  }
  return false;
}

function matchesRouteSuffixes(screen, suffixes) {
  const route = normalizeRoute(screen);
  if (!route) return false;
  return suffixes.some((suffix) => {
    const s = suffix.toLowerCase().replace(/\/+$/, '');
    return route === s || route.endsWith(s);
  });
}

export function findWorkingHoursScreen() {
  for (const module of loadMenuDataForNavigation()) {
    if (module?.isActive === false) continue;
    for (const screen of module.submenu || []) {
      if (!screen || screen.isActive === false || !screenHasAnyAccess(screen)) continue;
      const nameMatch = matchesScreenKeySet(screen, WORKING_HOURS_SCREEN_KEYS);
      const routeMatch = matchesRouteSuffixes(screen, WORKING_HOURS_ROUTE_SUFFIXES);
      if (nameMatch || routeMatch) {
        return screen;
      }
    }
  }
  return null;
}

export function getWorkingHoursScreenPermissions() {
  return permissionsFromScreen(findWorkingHoursScreen());
}

export function hasAnyWorkingHoursAccess() {
  const p = getWorkingHoursScreenPermissions();
  return p.canView || p.canInsert || p.canUpdate || p.canDelete;
}
